import moment from "moment";

/**
 * Stanje izveštaja u adresi (hash router: /#/izvestaj?r=taken&from=…&to=…&sh=123&c=1,2&v=1).
 * Prazna vrednost znači podrazumevano: sve smene, sve firme, prvi izveštaj prikaza.
 */
export const QUERY_KEYS = {
  report: "r",
  from: "from",
  to: "to",
  shifts: "sh",
  companies: "c",
  view: "v",
  legacy: "ui",
};

export const ALL_SHIFTS = [1, 2, 3, 4];
export const LEGACY_UI_VALUE = "stari";

const ISO = "YYYY-MM-DD";

/** "123" → [1, 2, 3]; neispravno ili prazno → null (ostaje podrazumevano) */
export const parseShifts = (value) => {
  const list = [
    ...new Set(
      String(value || "")
        .split("")
        .map(Number)
        .filter((shift) => ALL_SHIFTS.includes(shift))
    ),
  ].sort();
  return list.length ? list : null;
};

export const serializeShifts = (shifts) =>
  shifts.length === ALL_SHIFTS.length ? undefined : [...shifts].sort().join("");

/** "1115,1116" → [1115, 1116] */
export const parseIds = (value) =>
  String(value || "")
    .split(",")
    .map(Number)
    .filter((id) => Number.isInteger(id) && id > 0);

export const serializeIds = (ids, total) =>
  !ids.length || ids.length === total ? undefined : ids.join(",");

/** Vraća [from, to] samo ako su oba ispravna datuma, inače null */
export const parseRange = (from, to) => {
  const start = moment(from, ISO, true);
  const end = moment(to || from, ISO, true);
  if (!start.isValid() || !end.isValid()) {
    return null;
  }
  return start.isAfter(end) ? [end.format(ISO), start.format(ISO)] : [start.format(ISO), end.format(ISO)];
};
